import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useProjectProgress } from '../../contexts/ProjectProgressContext';

/**
 * NavigationBlocker component that intercepts navigation attempts
 * and shows save dialog when there are unsaved changes
 */
const NavigationBlocker = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { hasUnsavedChanges, currentProject, showSaveDialog, setShowSaveDialog, setPendingNavigation, saveProjectProgress } = useProjectProgress();

  useEffect(() => {
    if (!hasUnsavedChanges || !currentProject || showSaveDialog) {
      return;
    }

    // Store the original navigate function
    const originalNavigate = navigate;

    // Override navigate to check for unsaved changes
    const checkAndNavigate = (to, options) => {
      const targetPath = typeof to === 'string' ? to : (to?.pathname || '/');
      
      // Allow navigation within project flow
      const projectPaths = ['/preview/', '/filters/', '/cards/', '/dashboard/'];
      const isProjectPath = projectPaths.some(path => targetPath.startsWith(path));
      const isLandingPage = targetPath === '/landing';
      
      // If navigating away from project pages, show save dialog
      if (!isProjectPath && !isLandingPage && targetPath !== location.pathname) {
        setPendingNavigation(targetPath);
        setShowSaveDialog(true);
        return; // Block navigation
      }
      
      // Allow navigation
      return originalNavigate(to, options);
    };

    // This is a workaround - we can't actually override navigate
    // Instead, we'll rely on click interception and beforeunload
  }, [hasUnsavedChanges, currentProject, location.pathname, navigate, showSaveDialog, setShowSaveDialog, setPendingNavigation]);

  return null;
};

export default NavigationBlocker;
